import _ from 'underscore';

const subscribeToDayTimeViewModel = callback => (dayTimeViewModel) => {
  dayTimeViewModel.startHour.subscribe(callback);
  dayTimeViewModel.startMinute.subscribe(callback);
  dayTimeViewModel.endHour.subscribe(callback);
  dayTimeViewModel.endMinute.subscribe(callback);
};

const validateDayTimeRange = callback => (changes) => {
  callback();
  _.each(changes, ({ status, value: dayTimeViewModel }) => {
    if (status === 'added') {
      subscribeToDayTimeViewModel(callback)(dayTimeViewModel);
    }
  });
};

export const subscribeToSchedulingViewLiveUpdates = (view, callback) => {
  const { ko_model: viewModel } = view;
  viewModel.startDate.subscribe(callback);
  viewModel.endDate.subscribe(callback);
  viewModel.flattenedDayTimeRanges.subscribe(callback);
  viewModel.dayTimeRanges.subscribe(validateDayTimeRange(callback), undefined, 'arrayChange');
  _.each(viewModel.dayTimeRanges(), subscribeToDayTimeViewModel(callback));
  viewModel.useSearcherTimeZone.subscribe(callback);
};
